import { render, staticRenderFns } from "./DeleteBatchDialog.vue?vue&type=template&id=ce65cd1a&"
import script from "./DeleteBatchDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteBatchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports